// System font stacks — no Google Fonts or web fonts to keep printing reliable
// across all environments. Courier for prices keeps numeric columns aligned.
const SANS = '"Helvetica Neue", Helvetica, Arial, sans-serif';
const MONO = '"Courier New", Courier, monospace';

/**
 * CSS for the A4 print receipt. Injected inline into the print iframe.
 */
export function getWidgetReceiptCss(): string {
    return `
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @page { size: A4; margin: 20mm; }
        body {
            font-family: ${SANS};
            font-size: 12px;
            line-height: 1.5;
            color: #1a1a1a;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
        table { border-collapse: collapse; width: 100%; }
        img { max-width: 100%; }

        .receipt-brand {
            text-align: center;
            margin-bottom: 16px;
        }
        .receipt-brand img {
            max-height: 48px;
            width: auto;
        }

        .receipt-divider {
            border: none;
            border-top: 1px solid #ddd;
            margin: 12px 0;
        }
        .receipt-divider-dashed {
            border: none;
            border-top: 1px dashed #ccc;
            margin: 12px 0;
        }
        .receipt-divider-bold {
            border: none;
            border-top: 2px solid #1a1a1a;
            margin: 10px 0;
        }

        .receipt-header {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            gap: 16px;
        }
        .receipt-heading {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0.08em;
            text-transform: uppercase;
        }
        .receipt-ref {
            font-size: 13px;
            font-weight: 600;
        }
        .receipt-ref-value {
            font-family: ${MONO};
            font-weight: 700;
        }

        .receipt-group {
            margin-top: 16px;
            page-break-inside: avoid;
        }
        .receipt-group-name {
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 8px;
        }
        .receipt-item {
            margin-bottom: 10px;
        }
        .receipt-item-name {
            font-size: 13px;
            font-weight: 600;
        }
        .receipt-item-date {
            font-size: 11px;
            color: #555;
            margin-bottom: 4px;
        }
        .receipt-tickets td {
            padding: 3px 0;
            vertical-align: top;
        }
        .receipt-tickets td.ticket-label {
            font-size: 12px;
        }
        .receipt-tickets td.ticket-original {
            font-family: ${MONO};
            font-size: 11px;
            color: #999;
            text-decoration: line-through;
            text-align: right;
            padding-right: 12px;
            white-space: nowrap;
        }
        .receipt-tickets td.ticket-price {
            font-family: ${MONO};
            font-weight: 500;
            text-align: right;
            white-space: nowrap;
        }

        .receipt-totals {
            margin-top: 8px;
        }
        .receipt-totals tr td {
            padding: 3px 0;
            font-size: 12px;
        }
        .receipt-totals td.totals-label {
            text-align: right;
            color: #555;
            padding-right: 12px;
        }
        .receipt-totals td.totals-amount {
            font-family: ${MONO};
            font-weight: 500;
            text-align: right;
            white-space: nowrap;
            width: 1%;
        }
        .receipt-totals tr.grand-total td {
            font-size: 18px;
            font-weight: 700;
            padding-top: 8px;
        }
        .receipt-totals tr.grand-total td.totals-label {
            color: #1a1a1a;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }
        .receipt-totals tr.grand-total td.totals-amount {
            font-family: ${SANS};
        }

        .receipt-footer {
            margin-top: 16px;
            font-size: 11px;
            color: #555;
        }
    `;
}
